import React, { Dispatch, SetStateAction } from "react";
import { Box, Button, FormControl, MenuItem, Select, Typography } from "@mui/material";

import { tl } from "../../../../components/translate";
import { GlassOrderStatus } from "../../../../enum/GlassOrder";
import { Client } from "../../../../interfaces/ClientInterface";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import OpdRequestClientSearch from "../../OpdRequest/OpdRequestClientSearch";

export interface GlassOrderListHeaderProps {
  enableCreateNew?: boolean;
  onCreateOrder?: () => void;
  selectedClient: Partial<Client> | null;
  setSelectedClient: Dispatch<SetStateAction<Partial<Client> | null>>;
  statusFilter: string;
  setStatusFilter: Dispatch<SetStateAction<string>>;
  setPage?: Dispatch<SetStateAction<number>>;
}

// eslint-disable-next-line import/prefer-default-export
export const GlassOrderListHeader = ({
  enableCreateNew = true,
  onCreateOrder,
  selectedClient,
  setSelectedClient,
  statusFilter,
  setStatusFilter,
  setPage
}: GlassOrderListHeaderProps): React.JSX.Element => {
  const isMobileScreen = useMobileScreen();

  return (
    <Box
      sx={{
        height: "50px",
        width: "100%",
        px: 2,
        py: 1.5,
        display: "flex",
        gap: 1.5,
        justifyContent: { xs: "flex-end", md: "space-between" },
        alignItems: "center",
        borderBottom: 1,
        borderColor: "divider"
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column"
        }}
      >
        <Typography variant="body1" color="text.secondary" sx={{ fontWeight: 700 }}>
          Glass Orders
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flexWrap: "wrap",
          justifyContent: { xs: "flex-start", md: "flex-end" }
        }}
      >
        <OpdRequestClientSearch
          selectedClient={selectedClient}
          setSelectedClient={(client) => {
            setSelectedClient(client);
            if (setPage) {
              setPage(0);
            }
          }}
        />

        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value);
              if (setPage) {
                setPage(0);
              }
            }}
            variant="outlined"
            sx={{ height: 35, backgroundColor: "#ededed" }}
          >
            <MenuItem value="all">All Statuses</MenuItem>
            <MenuItem value={GlassOrderStatus.PENDING}>Pending</MenuItem>
            <MenuItem value={GlassOrderStatus.IN_PROGRESS}>In Progress</MenuItem>
            <MenuItem value={GlassOrderStatus.COMPLETED}>Completed</MenuItem>
            <MenuItem value={GlassOrderStatus.DELIVERED}>Delivered</MenuItem>
            <MenuItem value={GlassOrderStatus.CANCELLED}>Cancelled</MenuItem>
          </Select>
        </FormControl>

        {enableCreateNew && (
          <Button
            variant="contained"
            color="primary"
            onClick={onCreateOrder}
            data-testmation="createGlassOrderBtn"
          >
            {isMobileScreen ? tl("create") : "Create Glass Order"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default GlassOrderListHeader;
